// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2260 ? "a2b399f0" : chunkId) + "." + {"2002":"d55a209a9c442718","2260":"542ccfd510e1b9a4","6031":"75aefc0443af041a","7908":"5d564b0c1db23f17","8765":"075290e5d814bfea"}[chunkId] + ".js";
};